// CN marketplace configurations related to YourAccount scope.
import { MEDIA_CENTRAL_LINKS } from '@/configs/common';
import { i18n } from '@/local';
const { t } = i18n.global;

// YourAccount tabs configurations
export const YOUR_ACCOUNT_TABS = Object.freeze({
  ORDER: [
    {
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/backIcon.svg`,
      KEY: 'noShipmentCount',
      PATH: 'yoOrderList',
      PARAMS: 2,
      NAME: t('modules.toBeShipped')
    },
    {
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/transportingIcon.svg`,
      KEY: 'deliveryingCount',
      PATH: 'yoOrderList',
      PARAMS: 3,
      NAME: t('modules.toBeReceived')
    },
    {
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/criticizeIcon.svg`,
      KEY: 'toBeCommentedCount',
      PATH: 'yoCustomerReview',
      PARAMS: '',
      NAME: t('modules.toBeCommented')
    },
    {
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/refundIcon.svg`,
      KEY: 'afterSaleCount',
      PATH: 'asList',
      PARAMS: '',
      NAME: t('modules.yourOrder.AFTER_SALE')
    },
    {
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/indentIcon.svg`,
      KEY: 'totalOrderCount',
      PATH: 'yoOrderList',
      PARAMS: 1,
      NAME: t('modules.myOrder')
    }
  ],
  DEAL: [
    {
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/couponIcon.svg`,
      PATH: 'couponsList',
      NAME: t('modules.coupon')
    },
    {
      KEY: 'todayDeal',
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/treasureIcon.svg`,
      PATH: 'todayDeal',
      NAME: t('modules.TODAY_DEAL')
    },
    {
      KEY: 'bestSellingRecommendations',
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/rankingIcon.svg`,
      PATH: '',
      NAME: t('modules.yourAccount.RECOMMENDED_ASIN')
    }
  ],
  CUSTOMER: [
    {
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/icon_yourAccount_address.svg`,
      PATH: 'addressList',
      NAME: t('modules.deliveryAddress')
    },
    {
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/icon_yourAccount_identity.svg`,
      PATH: 'kycList',
      NAME: t('modules.clearanceInformation')
    },
    {
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/icon_yourAccount_service.svg`,
      PATH: 'contactCS',
      NAME: t('modules.contactCS')
    },
    {
      KEY: 'businessLicense',
      ICON: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/icon_yourAccount_business.svg`,
      PATH: 'businessLicense',
      NAME: t('modules.yourAccount.BUSINESS_LICENSE')
    }
  ]
});

// Items in YourAccount Setting
export const YOUR_ACCOUNT_SETTING_ITEMS = Object.freeze({
  CUSTOMER_MANAGEMENT: [
    {
      TITLE: t('modules.yourAccount.MANAGE_ADDRESS'),
      PATH: 'addressList'
    },
    {
      TITLE: t('modules.yourAccount.MANAGE_ID_CARD_INFORMATION'),
      DESCRIPTION: t('modules.yourAccount.GS_FOR_DOMESTIC_CUSTOMS_CLEARANCE'),
      PATH: 'kycList'
    }
  ],
  APP_SETTINGS: [
    {
      TITLE: t('modules.yourAccount.MANAGE_AUTH'),
      PATH: 'authorizationManagement'
    },
    {
      TITLE: t('modules.yourAccount.AD_PREFERENCES'),
      PATH: 'adPreference'
    },
    {
      TITLE: t('modules.yourAccount.PERS_REC'),
      PATH: 'personalizedRecommendation'
    },
    {
      TITLE: t('modules.yourAccount.NOTIFICATION_REMINDER_SETTINGS'),
      PATH: 'notificationReminder'
    }
  ],
  ABOUT_APP: [
    {
      TITLE: t('modules.yourAccount.PRIVACY_AND_SECURITY'),
      PATH: 'privacySecurity'
    },
    {
      TITLE: t('modules.yourAccount.CLEAR_CACHE'),
      CACHE_SIZE_TYPE: true,
      PATH: ''
    },
    {
      TITLE: t('modules.yourAccount.ABOUT_AMAZON'),
      CURRENT_APP_VERSION: true,
      PATH: 'aboutApp'
    }
  ]
});

// NotificationItems Type
export const MESSAGE_TYPE = {
  IMAGETEXT: '1',
  TWEET: '2'
};

// Transaction Notice ID
export const TRANSACTION_NOTICE_ID = 'AAHKV2X7AFYLW#通知';

// click event mappings
export const CLICK_EVENTS_MAPPINGS = Object.freeze({
  noShipmentCount: 'filterToBeShippedOrdersButton',
  deliveryingCount: 'filterToBeDeliveredOrdersButton',
  toBeCommentedCount: 'filterToBeReviewedOrdersButton',
  afterSaleCount: 'gotToReturnAndAfterSalesButton',
  totalOrderCount: 'getMyOrdersButton',
  couponsList: 'getMyCouponsButton',
  addressList: 'getMyShippingAddressButton',
  kycList: 'getCustomsClearanceInfoButton',
  contactCS: 'contactCustomerServiceButton'
});

// CUSTOMIZED_REDIRECT
export const CUSTOMIZED_REDIRECT = 'AAHKV2X7AFYLW#zh-CN_自定义跳转';
